import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import { MilestonePaymentAcknowledgementRuleset } from '../../business/ruleset';

const { milestonePaymentAcknowledgement } = loanFormModel.formField;

export class MilestonePaymentAcknowledgementValidation
  implements ValidationSchema
{
  public name = milestonePaymentAcknowledgement.name;
  public label = milestonePaymentAcknowledgement.getLabel('Borrower');
  public type = 'boolean';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = MilestonePaymentAcknowledgementRuleset;

  public when(schema: Yup.BooleanSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    return schema.test({
      name: 'milestonePaymentAcknowledgementTest',
      test: function (value) {
        if (required) {
          // Field is required - validate it has value and is true
          return (
            value ||
            this.createError({
              message: milestonePaymentAcknowledgement.requiredErrorMsg,
            })
          );
        } else {
          // Field is not required - any value is acceptable
          return true;
        }
      },
    });
  }
}
export default new Validation(new MilestonePaymentAcknowledgementValidation());
